import { SET_SNACKBAR } from "../constants/ActionTypes";

const initialState = {
    open: false,
    variant: "success",
    message: "",
  };

  export default function snackBarReducer(state = initialState, action) {
    if (action.type === SET_SNACKBAR) {
      return Object.assign({}, state, {
        open: action.payload.open,
        variant: action.payload.variant,
        message: action.payload.message
      });
    }
    return state;
  };